import React, { useState } from 'react';
import { handleKeyWords, handleTags, isValidTags } from '../../utils';
import { Modal, Form, Input, Button, TextArea } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';

interface CreateVersionProps {
  data?: {
    // 编辑情况下传入的表单数据
    id: number;
    version_id: number;
    module_name: string;
    keywords: string;
    tags: string;
    status: number;
  };
  closeModal: () => void;
  inputContentStatus: boolean;
  handleInputContentStatus: (value: boolean) => void;
  gameInfo: any;
  handleModules: (params: any) => void;
  loading: boolean;
}

export default function CreateModule({
  closeModal,
  inputContentStatus,
  handleInputContentStatus,
  data,
  handleModules,
  loading,
}: CreateVersionProps) {
  // 模块名称、关键词、标签
  const [moduleName, setModuleName] = useState(data?.module_name || '');
  const [keyWords, setKeyWords] = useState(
    handleKeyWords(data?.keywords) || '',
  );
  const { formatMessage } = useLanguage();
  const [tags, setTags] = useState(handleTags(data?.tags) || '');
  const HIDE_TAG = useFrontWebConfig({
    keys: 'hide_weekly_report_tags',
  });
  // 提交事件
  const submits = () => {
    // 判断必填值内容 和 标签的内容格式是否符合要求
    if (moduleName && keyWords && isValidTags(tags)) {
      const params = {
        ...(data?.id && { id: data.id }),
        ...(data?.version_id && { version_id: data.version_id }),
        module_name: moduleName,
        keywords: handleKeyWords(keyWords, true),
        tags: handleTags(tags, true),
        ...(data?.status && { status: data.status }),
      };

      handleModules(params);
    } else {
      handleInputContentStatus(true);
    }
  };

  return (
    <Modal
      className="dbo-create-version-modal"
      caption={formatMessage(data?.module_name ? 'Edit Module' : 'Add modules')}
      visible
      onClose={() => closeModal()}
    >
      <Modal.Body>
        <Form>
          <Form.Item
            required
            label={formatMessage('Module Name')}
            showStatusIcon={false}
            status={inputContentStatus && !moduleName ? 'error' : undefined}
            message={
              inputContentStatus && !moduleName
                ? formatMessage('Please enter the module name')
                : ''
            }
          >
            <Input
              size="full"
              value={moduleName}
              onChange={(value) => {
                setModuleName(value);
              }}
              placeholder={formatMessage('Please enter')}
            />
          </Form.Item>
          <Form.Item
            required
            label={formatMessage('Keywords')}
            showStatusIcon={false}
            status={inputContentStatus && !keyWords ? 'error' : undefined}
            message={
              inputContentStatus && !keyWords
                ? formatMessage(
                    'Please enter keywords according to the format requirements',
                  )
                : ''
            }
          >
            <TextArea
              className="dbo-textarea-h200"
              size="full"
              value={keyWords}
              onChange={(value) => {
                setKeyWords(value);
              }}
              placeholder={formatMessage(
                'Separate keywords using ( , )( ; )( 、) ( | ), or line breaks',
              )}
            />
          </Form.Item>
          {HIDE_TAG ? null : (
            <Form.Item
              label={formatMessage('Tags')}
              message={
                inputContentStatus && !isValidTags(tags) ? (
                  <div style={{ color: '#ef5858' }}>
                    {formatMessage(
                      'Please enter tags according to the format requirements',
                    )}
                  </div>
                ) : (
                  ''
                )
              }
            >
              <TextArea
                size="full"
                value={tags}
                onChange={(value) => {
                  setTags(value);
                }}
                placeholder={formatMessage(
                  'Please enter in the following format: Tags: keywords, keywords; Tags: keywords, keywords. Use (;) to separate tags, and do not use (;) at the end of the last tag.',
                )}
              />
            </Form.Item>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button loading={loading} type="primary" onClick={submits}>
          {formatMessage('Confirm')}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            handleInputContentStatus(false);
            closeModal();
          }}
        >
          {formatMessage('Cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
